import { BASE_QUERY_PRO, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from '../shared/configs';

enum SECTION_ENUM {
  NEW_MONEY = 'New Money',
  COMMENTARY_ANALYSIS = 'Commentary & Analysis',
  LIFE_SCIENCES = 'Life Sciences'
}

const VENTURE_CAPITAL_QUERIES = {
  COMMENTARY_ANALYSIS: 'pro vc commentary analysis',
  INDUSTRY_NEWS: 'pro vc industry news',
  MA_IPOS: 'pro vc ma ipos',
  NEW_MONEY: 'pro vc new money'
};

const TOPIC_CODES = {
  VCLIFESCINCES: 'vclifescinces'
};

const MAIN = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus],
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            VENTURE_CAPITAL_QUERIES.INDUSTRY_NEWS,
            VENTURE_CAPITAL_QUERIES.MA_IPOS,
            VENTURE_CAPITAL_QUERIES.NEW_MONEY
          ]
        }
      },
      {
        terms: {
          key: 'TopicCode',
          value: [TOPIC_CODES.VCLIFESCINCES]
        }
      }
    ]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const NEW_MONEY = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: [VENTURE_CAPITAL_QUERIES.NEW_MONEY] } }]
  }
};

const COMMENTARY_AND_ANALYSIS = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: [VENTURE_CAPITAL_QUERIES.COMMENTARY_ANALYSIS] } }]
  }
};

const LIFE_SCIENCES = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'TopicCode', value: [TOPIC_CODES.VCLIFESCINCES] } }] }
};

const MORE = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus],
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            VENTURE_CAPITAL_QUERIES.COMMENTARY_ANALYSIS,
            VENTURE_CAPITAL_QUERIES.INDUSTRY_NEWS,
            VENTURE_CAPITAL_QUERIES.MA_IPOS,
            VENTURE_CAPITAL_QUERIES.NEW_MONEY
          ]
        }
      }
    ]
  }
};

export { MAIN, SECTION_TOP, NEW_MONEY, COMMENTARY_AND_ANALYSIS, LIFE_SCIENCES, MORE, SECTION_ENUM };
